<template>
<div class="chapter">
<div class="inner_page">
<p class="p15"><img alt="img2.png" src="images/img2.png"/></p>
<p class="p14"><span class="t8"> </span></p>
<p class="p16"><span class="t9">The best of intentions by some are invariably tarnished by others. Evil is always watching, seeking, waiting. It preys upon weak minds and cold hearts. It silently seeps its way into the smallest of openings, a tortured soul, and a hint of doubt. Evil is a cancer spreading its poison to everything it touches. Some embrace the evil, relish in it, become a servant to it, a pestilence. Others sit passively by, deem it necessary, and in doing so, help perpetrate it.</span></p>
<p class="p16"><span class="t9">I read once something by Bodhidharma. “The ignorant mind, with its infinite afflictions, passions, and evils, is rooted in the three poisons. Greed, anger, and delusion.”</span></p>
<p class="p16"><span class="t9">My poison was delusion.</span></p>
<p class="p16"> </p>
<p class="p16"><span class="t9">Tek Cain</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 011.vue?1349274a